import { useEffect, useRef } from 'react';
import { useUserAgent } from 'src/common/userAgent/useUserAgent';
import WF_GeneralMenu from './WF_GeneralMenu';
import WF_HistoryMenu from './WF_HistoryMenu';
import WF_TyphoonInfo from './WF_TyphoonInfo';
import { useWfLocationService } from 'src/api/wf/service/WfLocationService';
import { useWfUserStore } from 'src/api/wf/stores/WfUserStore';

type WF_MenuProps = {
  typhoonInfo?: boolean;
  generalMenu?: boolean;
  historyMenu?: boolean;
};

function WF_Menu({ typhoonInfo, generalMenu, historyMenu }: WF_MenuProps) {
  const userAgent = useUserAgent();
  const { updateWfUserLocation } = useWfLocationService();
  const { user } = useWfUserStore();

  const hasUserUpdatedRef = useRef(false);

  useEffect(() => {
    if (!user || hasUserUpdatedRef.current) return;

    hasUserUpdatedRef.current = true;
    updateWfUserLocation();
  }, [user, updateWfUserLocation]);

  return (
    <div className={userAgent.isDesktop ? 'w-64 shrink-0 space-y-1 p-2' : 'mt-4 w-full'}>
      {typhoonInfo && <WF_TyphoonInfo />}
      {generalMenu && <WF_GeneralMenu />}
      {historyMenu && <WF_HistoryMenu />}
    </div>
  );
}

export default WF_Menu;
